import React from 'react'
import { Switch, Route } from "react-router-dom"
import SaleController from './sales/sales.page'

const ReportController = () => {
    return (
        <div className="report">
            <Switch>
                <Route path="/report/sale" component={SaleController} />
            </Switch>
        </div>
    )
}

export default ReportController